import React, { ReactNode, useEffect, useState } from 'react'
import PageHeader from '../partials/PageHeader'
import { Color } from '../utils/constants'
import { FormattedMessage } from 'react-intl'
import Separator from '../components/Separator'
import { slug } from '../utils/helpers'
import FadeIn from '../components/Animation/FadeIn'
import api from '../utils/api'
import parse from 'html-react-parser'
import Image from '../components/Image'

const EuGrants = () => {
    const [posts, setPosts] = useState<Record<string, ReactNode>>({})
    const [titles, setTitles] = useState<Record<string, boolean>>({})
    useEffect(() => {
        const getData = (object: any): string => {
            if (object.data) return object.data
            return getData(object.children[0])
        }

        const parseOptions = {
            // @ts-ignore
            replace: (domNode) => {
                // @ts-ignore
                if (domNode.name === 'h5') {
                    const data = getData(domNode)
                    setTitles((currentTitles) => {
                        const titlesCopy = { ...currentTitles }
                        titlesCopy[data] = false
                        return titlesCopy
                    })
                    return (
                        <h5 id={slug(data)} className='pb-4'>
                            {data}
                        </h5>
                    )
                }
            },
        }

        api.get('/wp-json/categories/v1/posts?name=eu-grants').then((response) => {
            const parsedPosts = response.data.reduce(
                (
                    allPosts: { [x: string]: string | JSX.Element | JSX.Element[] },
                    post: { [x: string]: any },
                ) => {
                    setTitles((currentTitles) => {
                        const titlesCopy = { ...currentTitles }
                        titlesCopy[post['post_title']] = true
                        return titlesCopy
                    })
                    allPosts[post['post_title']] = parse(post?.['post_content'] ?? '', parseOptions)
                    return allPosts
                },
        {} as Record<string, ReactNode>,
            )
            setPosts(parsedPosts)
        })
    }, [])
    return (
        <FadeIn>
            <div>
                <PageHeader bgColor={Color.WHITE} link={'/'}>
                    <></>
                </PageHeader>
                <div className='side-padding-md 3xl:max-w-screen-2xl mx-auto'>
                    <div className='py-12 md:py-24'>
                        <div className='flex justify-between items-center flex-col md:flex-row gap-y-5'>
                            <FormattedMessage id={'page.euGrants'} tagName='h1' />
                            <Image slug={'eu-grants-logo'} alt='eu-grants-logo' className='md:max-w-[330px]' />
                        </div>
                        <Separator className='my-16' />
                    </div>
                    <div className='grid gap-x-24' style={{ gridTemplateColumns: '315px auto' }}>
                        <div className='md:flex flex-col gap-y-4 sticky top-40 self-start hidden'>
                            {Object.entries(titles).map(([title, isMajor]) => (
                                <button
                                    key={title}
                                    onClick={() => {
                                        const element = document.querySelector(`#${slug(title)}`)
                    element?.scrollIntoView({ behavior: 'smooth' })
                                    }}
                                    className='text-left'
                                >
                                    {isMajor ? <h5>{title}</h5> : title}
                                </button>
                            ))}
                        </div>
                        <div className='privacy-policy--post max-w-[630px]'>
                            {Object.entries(posts).map(([title, post]) => (
                                <div key={`policy-${title}`}>
                                    <h4 className='pb-6' id={slug(title)}>
                                        {title}
                                    </h4>
                                    {post}
                                    <Separator className='my-10' />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </FadeIn>
    )
}

export default EuGrants
